import { createContext, Dispatch } from 'react';

interface Props {
  updatedCount: number | undefined;
  setUpdatedCount: Dispatch<number | undefined>;
}

const NotificationContext = createContext<Props>({
  updatedCount: undefined,
  setUpdatedCount: () => {},
});

export default NotificationContext;
